import { dateFormatPayload } from './date.constant';

export const getDefaultTargetingPayload = ({ datePayload, smartFilter }) => {
  return {
    ...(Object.keys(smartFilter).length > 0
      ? {
          smart_search_filters: smartFilter,
          start_date: dateFormatPayload(smartFilter?.dateInfo?.startDate),
          end_date: dateFormatPayload(smartFilter?.dateInfo?.endDate),
          compare_start_date: dateFormatPayload(smartFilter?.dateInfo?.pastStartDate),
          compare_end_date: dateFormatPayload(smartFilter?.dateInfo?.pastEndDate)
        }
      : {
          start_date: dateFormatPayload(datePayload.startDate),
          end_date: dateFormatPayload(datePayload.endDate),
          compare_start_date: dateFormatPayload(datePayload?.pastStartDate),
          compare_end_date: dateFormatPayload(datePayload?.pastEndDate),
        }),
        ...(window.location.href.includes('amazon/marketing-stream') && datePayload?.hourFilter ? {
            hourFilter: datePayload?.hourFilter?.filter((item) => item.checked == 1 || item.checked == true).map((item) => item.value)
        } : {})
  };
};

export const ASIN_REGEX = /^\d+$/; 



export const isExecutive = (accessLevel) => {
  return String(accessLevel).toLowerCase() === 'executive'
}

export const isAllowedDomain = () => {
  const authUser = JSON.parse(localStorage.getItem('User'));
  return authUser?.email && (authUser?.email?.includes('@hectorai') || authUser?.email?.includes('@neondigital'))
};